import script from "./PreviewFallback.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewFallback.vue?vue&type=script&setup=true&lang=js"

import "./PreviewFallback.vue?vue&type=style&index=0&id=61a5daa1&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61a5daa1"]])

export default __exports__